import React from 'react';
import { Card, ListGroup } from 'react-bootstrap';
import { useAuth } from '../../contexts/AuthContext';

const Profile = () => {
  const { user } = useAuth();

  return (
    <Card className="mb-4">
      <Card.Header as="h5">My Profile</Card.Header>
      <Card.Body>
        <div className="text-center mb-3">
          <div className="bg-light rounded-circle d-inline-flex align-items-center justify-content-center" style={{ width: '80px', height: '80px' }}>
            <span className="text-primary fs-1">
              {user.first_name?.charAt(0) || user.email?.charAt(0)}
            </span>
          </div>
          <h5 className="mt-2 mb-0">{`${user.first_name || ''} ${user.last_name || ''}`}</h5>
          <p className="text-muted">{user.email}</p>
        </div>
        
        <ListGroup variant="flush">
          <ListGroup.Item>
            <strong>Phone:</strong> {user.phone_number || 'Not provided'}
          </ListGroup.Item>
          <ListGroup.Item>
            <strong>Hostel:</strong> {user.hostel_name || 'Not provided'}
          </ListGroup.Item>
          <ListGroup.Item>
            <strong>Room Number:</strong> {user.room_number || 'Not provided'}
          </ListGroup.Item>
          <ListGroup.Item>
            <strong>Registration Status:</strong>{' '}
            {user.is_registration_complete ? (
              <span className="text-success">Complete</span>
            ) : (
              <span className="text-warning">Incomplete</span>
            )}
          </ListGroup.Item>
          <ListGroup.Item>
            <strong>Portal Access:</strong>{' '}
            {user.can_access_portal ? (
              <span className="text-success">Enabled</span>
            ) : (
              <span className="text-danger">Disabled</span>
            )}
          </ListGroup.Item>
        </ListGroup>
      </Card.Body>
    </Card>
  );
};

export default Profile;